module.exports = __webpack_public_path__ + "img/background052.jpg";